/* Mobile product framing. Desktop title and collection markup stay in place. */
(() => {
  const mobile = matchMedia('(max-width: 1200px)');
  function init() {
    const root = document.querySelector('.ak-product-split');
    const heading = root?.querySelector('.ak-session-one-heading__title');
    const media = root?.querySelector('.product-media-container');
    if (!root || !heading || !media) return;
    if (mobile.matches) root.dataset.akWallIntro = 'done';
    const specs = document.querySelector('[data-ak-details-label], .ak-posters-product-specs__label');
    const specSlot = specs?.closest('.ak-simple-session-2__label-slot');
    const specShell = document.querySelector('.ak-simple-session-2-shell');
    const originalSpecsText = specs?.textContent;
    const visuals = document.querySelector('[data-ak-visuals-label]');
    const originalVisualsText = visuals?.textContent;
    const posterSpecs = document.querySelector('.ak-posters-product-specs');
    const posterGallery = document.querySelector('.ak-posters-mobile-visuals');
    const specBlock = document.createElement('div');
    specBlock.className = 'ak-mobile-specs-block';
    const sectionHeads = [...document.querySelectorAll('.ak-simple-session-2__label, .ak-simple-mosaic__label, .ak-posters-product-specs__label, .ak-posters-visuals-label, .ak-session-6__title')];
    const sharedProductHeadings = root.matches('[data-ak-simple-product], [data-ak-posters-product]');
    const simpleLabels = sharedProductHeadings
      ? sectionHeads : [];
    [heading, ...simpleLabels].forEach(label => {
      if (sharedProductHeadings) label.classList.add('ak-mobile-simple-heading');
    });
    const related = document.querySelector('section.ak-session-6');
    const main = document.getElementById('MainContent');

    let mobileHeadingsApplied = false;
    function syncSectionHeadings() {
      if (!mobile.matches) {
        // Desktop owns its optical heading markup. Scroll/resize callbacks
        // must not replace those spans unless restoring an actual mobile view.
        if (!mobileHeadingsApplied) return;
        mobileHeadingsApplied = false;
        if (specs) specs.textContent = originalSpecsText;
        if (visuals) visuals.textContent = originalVisualsText;
        if (specBlock.parentNode) { specBlock.before(specSlot, specShell); specBlock.remove(); }
        sectionHeads.forEach(label => {
          label.style.removeProperty('font-size');
          label.style.removeProperty('--ak-shared-cart-heading-size');
        });
        related?.style.removeProperty('--ak-related-mobile-tail-space');
        window.akFitProductHeading?.(root);
        return;
      }
      mobileHeadingsApplied = true;
      if (specs && specs.textContent !== 'Specs') specs.textContent = 'Specs';
      if (visuals && visuals.textContent !== 'Visuals') visuals.textContent = 'Visuals';
      if (posterSpecs && related) {
        const portrait = related.querySelector('.ak-session-6__card:not([hidden]) [data-ak-room-format="portrait"][data-ak-room-display="card"]')
          || related.querySelector('[data-ak-room-format="portrait"][data-ak-room-display="card"]');
        const ratio = portrait ? parseFloat(getComputedStyle(portrait).getPropertyValue('--ak-room-aspect-ratio')) : 5 / 7;
        const value = String(Number.isFinite(ratio) && ratio > 0 ? ratio : 5 / 7);
        if (related.style.getPropertyValue('--ak-mobile-related-portrait-ratio') !== value) {
          related.style.setProperty('--ak-mobile-related-portrait-ratio', value);
        }
      }
      if (specSlot && specShell && !specBlock.parentNode) {
        specSlot.before(specBlock);
        specBlock.append(specSlot, specShell);
      }
      for (const label of sectionHeads) {
        const style = getComputedStyle(label);
        const context = document.createElement('canvas').getContext('2d');
        context.font = style.fontWeight + ' 100px ' + style.fontFamily;
        const word = label.textContent.trim().replace(/\s+/g, ' ').toUpperCase();
        const size = simpleLabels.includes(label)
          ? (parseFloat(root.style.getPropertyValue('--ak-wall-title-size')) || 32)
          : Math.min(label.clientWidth * .9 / context.measureText(word).width * 100, label.clientHeight * .8);
        label.style.setProperty('--ak-shared-cart-heading-size', size + 'px');
        label.style.setProperty('font-size', 'var(--ak-shared-cart-heading-size)', 'important');
      }

    }
    let frame = 0;
    function fit() {
      frame = 0;
      if (!mobile.matches) { syncSectionHeadings(); heading.setAttribute('aria-hidden', 'true'); return; }
      if (visualViewport && Math.abs(visualViewport.scale - 1) > .01) return;
      syncSectionHeadings();
      heading.removeAttribute('aria-hidden');
      const style = getComputedStyle(heading);
      const context = document.createElement('canvas').getContext('2d');
      context.font = style.fontWeight + ' 100px ' + style.fontFamily;
      const word = heading.textContent.trim().replace(/\s+/g, ' ');
      const metrics = context.measureText(word);
      const ink = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent || 75;
      const width = metrics.width - .025 * 100 * Math.max(0,word.length - 1);
      const originalSize = Math.min(59 * .8, (heading.clientWidth - 26) / width * 100);
      const reduction = sharedProductHeadings ? 4 : 2;
      const titleSize = Math.max(1, originalSize - reduction);
      root.style.setProperty('--ak-wall-title-size', titleSize + 'px');
      if (sharedProductHeadings) {
        // Preserve the product title's optical position. Section headings share
        // one baseline: descenders in Specs must not move the whole word up.
        for (const label of [heading, ...simpleLabels]) {
          context.font = style.fontWeight + ' ' + titleSize + 'px ' + style.fontFamily;
          const glyph = context.measureText(label === heading ? label.textContent.trim() : 'Visuals');
          const ascent = glyph.fontBoundingBoxAscent ?? titleSize * .93;
          const descent = glyph.fontBoundingBoxDescent ?? titleSize * .27;
          const lineGap = (titleSize - ascent - descent) / 2 + descent - glyph.actualBoundingBoxDescent;
          const leftGap = 13 - glyph.actualBoundingBoxLeft;
          label.style.setProperty('--ak-simple-heading-bottom', Math.max(0, leftGap - lineGap) + 'px');
          if (label !== heading) label.style.setProperty('--ak-shared-cart-heading-size', titleSize + 'px');
        }
      }
      root.style.setProperty('--ak-wall-title-bottom', ((60 - originalSize) / 2) + 'px');
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(fit); }
    const geometryObserver = new ResizeObserver(schedule);
    [heading, ...sectionHeads, posterSpecs, posterGallery, related, main].filter(Boolean).forEach(element => geometryObserver.observe(element));
    const styleObserver = new MutationObserver(records => {
      if (mobile.matches && records.some(record => record.target.style.getPropertyValue('font-size') !== 'var(--ak-shared-cart-heading-size)')) schedule();
    });
    sectionHeads.forEach(label => styleObserver.observe(label, {attributes:true, attributeFilter:['style']}));
    window.addEventListener('ak:global-frame-ready', schedule);
    window.addEventListener('ak:mobile-resume', schedule);
    main?.addEventListener('scroll', schedule, {passive:true});
    related?.addEventListener('load', schedule, true);
    mobile.addEventListener('change', schedule);
    window.addEventListener('resize', schedule, {passive: true});
    document.fonts.ready.then(schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();

/* One scroll-direction rule for every mobile product purchase panel. */
(() => {
  function initPurchaseScroll() {
    const product = document.querySelector('.ak-product-split:is([data-ak-simple-product], [data-ak-posters-product]), [data-ak-ath-product]');
    const main = document.getElementById('MainContent');
    if (!product || !main) return;
    const mobile = matchMedia('(max-width:1200px)');
    let kingpongOrigin;
    function rows() {
      const panel = product.querySelector('.ak-posters-mobile-purchase-panel');
      const choices = product.querySelector('.ak-kingpong-options');
      if (panel && choices) {
        if (mobile.matches && choices.parentElement !== panel) {
          if (!kingpongOrigin) {
            kingpongOrigin = document.createComment('Kingpong desktop choices');
            choices.before(kingpongOrigin);
          }
          panel.prepend(choices);
        } else if (!mobile.matches && kingpongOrigin && choices.parentElement === panel) {
          kingpongOrigin.after(choices);
        }
      }
      const controls = [...product.querySelectorAll('.ak-posters-mobile-purchase-panel, .ak-mobile-purchase-row, .ak-ath-product__purchase')];
      return controls.filter(control => !controls.some(parent => parent !== control && parent.contains(control)));
    }
    rows();
    new MutationObserver(rows).observe(product, {childList:true, subtree:true});
    let previous = main.scrollTop, direction = 0, distance = 0, frame = 0;
    function show(hidden) {
      product.classList.toggle('ak-purchase-scroll-hidden', hidden);
      rows().forEach(row => { row.inert = hidden; });
    }
    function locked() {
      return !mobile.matches || ['peek','return'].includes(product.dataset.akMobilePreviewPhase) || (product.matches('[data-ak-ath-product]')
        ? product.dataset.akProductEntrance !== 'done' : product.dataset.akMobileProductIntro !== 'complete') ||
        document.documentElement.matches('.ak-mobile-builder-open,.ak-search-overlay-open') ||
        document.body.classList.contains('ak-mobile-cart-is-open') ||
        !!product.querySelector('.ak-kingpong-trigger[aria-expanded="true"], .ak-ath-product__trigger[aria-expanded="true"], [data-ak-price-request-trigger][aria-expanded="true"]') ||
        rows().some(row => row.contains(document.activeElement) && document.activeElement.matches(':focus-visible'));
    }
    function update() {
      frame = 0;
      const current = Math.max(0, Math.min(main.scrollTop, main.scrollHeight - main.clientHeight));
      const delta = current - previous;
      previous = current;
      if (locked() || current < 40) { show(false); distance = 0; direction = 0; return; }
      if (Math.abs(delta) < 1) return;
      const nextDirection = Math.sign(delta);
      if (nextDirection !== direction) { direction = nextDirection; distance = 0; }
      distance += Math.abs(delta);
      if (distance >= (direction > 0 ? 40 : 28)) { show(direction > 0); distance = 0; }
    }
    main.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, {passive:true});
    product.addEventListener('focusin', () => show(false));
    new MutationObserver(() => { if (locked()) show(false); }).observe(document.documentElement, {attributes:true,attributeFilter:['class']});
    mobile.addEventListener('change', () => { show(false); previous = main.scrollTop; });
    window.addEventListener('pageshow', () => { show(false); previous = main.scrollTop; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPurchaseScroll, {once:true});
  else initPurchaseScroll();
})();

/* All Related sections share one mobile end seam, including Arthletics.
   The card owns the bottom border; its caption has no bottom border. */
(() => {
  const mobile=matchMedia('(max-width:1200px)');
  function init(){
    const main=document.getElementById('MainContent');
    const sections=[...document.querySelectorAll('section.ak-session-6')];
    if(!main || !sections.length)return;
    const fits=new Map();
    let frame=0;
    function restore(section){
      const fit=fits.get(section);
      if(!fit)return;
      for(const [property,value,priority] of fit.styles){
        if(value)fit.name.style.setProperty(property,value,priority);
        else fit.name.style.removeProperty(property);
      }
      fits.delete(section);
    }
    function sync(){
      frame=0;
      if(!mobile.matches){
        sections.forEach(section=>{restore(section);section.style.removeProperty('--ak-related-mobile-tail-space');});
        return;
      }
      if(!document.body.classList.contains('ak-global-frame-complete'))return;
      const rail=[...document.querySelectorAll('.ak-site-frame-rail--left .ak-site-frame-rail__grid--bottom')]
        .find(e=>e.getBoundingClientRect().height>0);
      if(!rail)return;
      const mainTop=main.getBoundingClientRect().top;
      const strokeTop=rail.getBoundingClientRect().top+(parseFloat(getComputedStyle(rail,'::before').top)||0);
      for(const section of sections){
        const cards=[...section.querySelectorAll('.ak-session-6__card:not([hidden])')].filter(e=>e.offsetHeight);
        const last=cards.reduce((last,e)=>!last||e.getBoundingClientRect().bottom>last.getBoundingClientRect().bottom?e:last,null);
        if(!last)continue;
        const name=last.querySelector('.ak-session-6__name');
        if(fits.has(section)&&fits.get(section).name!==name)restore(section);
        section.style.setProperty('--ak-related-mobile-scroll-padding',getComputedStyle(main).paddingBottom);
        const border=parseFloat(getComputedStyle(last).borderBottomWidth)||1;
        const target=strokeTop+border;
        const padding=parseFloat(getComputedStyle(section).paddingBottom)||0;
        const atEnd=main.scrollHeight-main.clientHeight-main.scrollTop<2;
        if(!atEnd){
          const bottom=last.getBoundingClientRect().bottom-mainTop+main.scrollTop;
          const endSpace=main.scrollHeight-bottom;
          const targetSpace=main.clientHeight-(target-mainTop);
          const next=Math.max(0,padding+targetSpace-endSpace);
          if(Math.abs(next-padding)>.5)section.style.setProperty('--ak-related-mobile-tail-space',next+'px');
          continue;
        }
        let error=last.getBoundingClientRect().bottom-target;
        if(Math.abs(error)>2){
          section.style.setProperty('--ak-related-mobile-tail-space',Math.max(0,padding+error)+'px');
          main.scrollTop=main.scrollHeight;
          error=last.getBoundingClientRect().bottom-target;
        }
        if(name&&Math.abs(error)>1/64&&Math.abs(error)<=2){
          if(!fits.has(section))fits.set(section,{name,styles:['height','min-height','max-height'].map(p=>[p,name.style.getPropertyValue(p),name.style.getPropertyPriority(p)])});
          const height=name.getBoundingClientRect().height-error;
          for(const p of ['height','min-height','max-height'])name.style.setProperty(p,height+'px','important');
          const tail=parseFloat(getComputedStyle(section).paddingBottom)||0;
          section.style.setProperty('--ak-related-mobile-tail-space',Math.max(0,tail+error)+'px');
          main.scrollTop=main.scrollHeight;
        }
      }
    }
    function schedule(){if(!frame)frame=requestAnimationFrame(sync);}
    const observer=new ResizeObserver(schedule);
    [main,...sections].forEach(e=>observer.observe(e));
    main.addEventListener('scroll',schedule,{passive:true});
    sections.forEach(e=>e.addEventListener('load',schedule,true));
    ['resize','pageshow','ak:global-frame-ready','ak:mobile-resume'].forEach(e=>window.addEventListener(e,schedule));
    mobile.addEventListener('change',schedule);
    document.fonts.ready.then(schedule);
    schedule();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

/* Mobile Related has one label and one gallery-bottom handoff on every product. */
(() => {
  const mobile=matchMedia('(max-width:1200px)');
  function init(){
    const main=document.getElementById('MainContent');
    const related=document.querySelector('section.ak-session-6');
    if(!main||!related)return;
    const title=related.querySelector('.ak-session-6__title');
    const desktopTitle=title?.dataset.akTitleDesktop||title?.textContent.trim();
    const shell=document.querySelector('[data-ak-simple-mosaic-shell],.ak-posters-mobile-visuals');
    const gallery=shell?.querySelector('[data-ak-simple-mosaic]')||shell;
    if(shell)shell.dataset.akGalleryHandoff='true';
    let frame=0;
    const set=(name,value)=>{if(shell.style.getPropertyValue(name)!==value)shell.style.setProperty(name,value);};
    function sync(){
      frame=0;
      if(title){
        title.dataset.akTitleMobile='Related';
        title.dataset.akTitleDesktop=desktopTitle;
        const text=mobile.matches?'Related':desktopTitle;
        const label=title.querySelector('.ak-title-fit')||title;
        if(label.textContent.trim()!==text)label.textContent=text;
      }
      if(!shell||!gallery)return;
      if(!mobile.matches){
        ['--ak-mobile-gallery-height','--ak-mobile-gallery-pin-top','--ak-related-handoff-gap'].forEach(name=>shell.style.removeProperty(name));
        return;
      }
      const rail=[...document.querySelectorAll('.ak-site-frame-rail--left .ak-site-frame-rail__grid--bottom')].find(e=>e.getBoundingClientRect().height>0);
      const nav=document.querySelector('.ak-bottom-nav');
      if(!rail||!nav)return;
      const railRect=rail.getBoundingClientRect();
      const seam=railRect.top+(parseFloat(getComputedStyle(rail,'::before').top)||0);
      // The gallery's final 1px border and the rail's painted stroke coincide.
      const target=seam+1;
      const height=gallery.offsetHeight;
      if(!height)return;
      const visibleBottom=nav.getBoundingClientRect().top;
      const gap=Math.max(0,visibleBottom-target);
      set('--ak-mobile-gallery-height',height+'px');
      set('--ak-mobile-gallery-pin-top',(target-main.getBoundingClientRect().top-height)+'px');
      set('--ak-related-handoff-gap',gap+'px');
    }
    function schedule(){if(!frame)frame=requestAnimationFrame(sync);}
    const observer=new ResizeObserver(schedule);
    [main,gallery,document.querySelector('.ak-site-frame-rail--left .ak-site-frame-rail__grid--bottom')].filter(Boolean).forEach(e=>observer.observe(e));
    gallery?.addEventListener('load',schedule,true);
    mobile.addEventListener('change',schedule);
    ['resize','pageshow','ak:global-frame-ready','ak:mobile-resume','ak-nav-grid-synced','ak-bottom-nav-grid-synced'].forEach(e=>window.addEventListener(e,schedule));
    document.fonts.ready.then(schedule);schedule();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
